// Types of action for requesting head to head players
export const REQUEST_HEAD_TO_HEAD_PLAYERS = 'REQUEST_HEAD_TO_HEAD_PLAYERS';
export const REQUEST_HEAD_TO_HEAD_PLAYERS_PENDING = 'REQUEST_HEAD_TO_HEAD_PLAYERS_PENDING';
export const REQUEST_HEAD_TO_HEAD_PLAYERS_SUCCESS = 'REQUEST_HEAD_TO_HEAD_PLAYERS_SUCCESS';
export const REQUEST_HEAD_TO_HEAD_PLAYERS_ERROR = 'REQUEST_HEAD_TO_HEAD_PLAYERS_ERROR';
// Types of action for requesting head to head players as csv
export const REQUEST_HEAD_TO_HEAD_PLAYERS_AS_CSV = 'REQUEST_HEAD_TO_HEAD_PLAYERS_AS_CSV';